export default __webpack_public_path__ + "static/media/z_wdt_c_0.9acc97da.mp3";